module.exports = __webpack_public_path__ + "images/76c02c1b1615079d2723ea9bc9163ea5.svg";